import Select2 from "react-select";
export default (props) => {

    return (
        <Select2
            {...props}
            
            className={"brtx-select2 form-control " + props.customclass}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: 'transparent',
                },
            })}
            styles={{
                control: (base) => ({
                    ...base,
                    border: '0 !important',
                    borderRadius: '4px !important',
                    // This line disable the blue border
                    boxShadow: '0 !important',
                    '&:hover': {
                        border: '1 !important'
                    },
                    
                }),
                option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused && "#f0f0f0",
                    color: state.isFocused && "#000",
                    cursor: state.isDisabled ? 'not-allowed' : 'default',
                    color: state.isDisabled ? '#aaa' : '#000'
                })
            }} />
    );
}